import request from './request';
/**
 *  获取工单列表
 */
export function getWorkOrderList(params) {
    return request('/work-order/list', {
        method: 'POST',
        params,
    });
}

/**
 * 创建工单
 */
export function createWorkOrder(params) {
    return request('/work-order', {
        method: 'POST',
        params,
    });
}
/**
 * 工单详情
 */
export function getWorkOrderDetail(id) {
    return request(`/work-order/${id}`, {
        method: 'GET',
    });
}

/**
 * 查询预约订单
 */
export function getBookingOrder(params) {
    return request('/work-order/booking-order', {
        method: 'GET',
        params,
    });
}

/**
 * 取消工单
 */
export function cancelWorkOrder(id, params) {
    return request(`/work-order/${id}/cancel`, {
        method: 'PATCH',
        params,
    });
}

/**
 * 交付工单
 */
export function resolveWorkOrder(id, params) {
    return request(`/work-order/${id}`, {
        method: 'PUT',
        params,
    });
}

/**
 * 获取维保项目
 */
export function getMaintainProjects() {
    return request('/work-order/maintain-project', {
        method: 'GET',
    });
}
/**
 *  获取工单操作记录
 */
export function getWorkOrderRecords(id, params) {
    return request(`/work-order/${id}/records`, {
        method: 'GET',
        params,
    });
}
/**
 *  获取工单相关枚举
 */
export function getWorkOrderEnum(params) {
    return request('/work-order/enum', {
        method: 'GET',
        params,
    });
}
/**
 *  获取工单相关权益
 */
export function getWorkOrderEquitys(id) {
    return request(`/work-order/${id}/equitys`, {
        method: 'GET',
    });
}
/**
 *  获取工单统计信息
 */
export function getWorkOrderOverview(params) {
    return request('/stat/work-order/overview', {
        method: 'POST',
        params,
    });
}

/**
 *  查询工单设置
 */
export function queryWorkOrderConfig() {
    return request('/work-order/config', {
        method: 'GET',
    });
}
/**
 *  编辑工单设置
 */
export function editWorkOrderConfig(params) {
    return request('/work-order/config', {
        method: 'PUT',
        params,
    });
}
/**
 *  获取工单设置操作记录
 */
export function getWorkOrderConfigRecords(id, params) {
    return request(`/work-order/config/${id}/records`, {
        method: 'GET',
        params,
    });
}

/**
 * 完善工单
 */
export function completeWorkOrder(id, params) {
    return request(`/work-order/${id}/compensate`, {
        method: 'PUT',
        params,
    });
}


/**
 *  查询服务顾问列表
 */
export function getAssigneesList(params) {
    return request('work-order/assignees', {
        method: 'GET',
        params,
    });
}

/**
 * 分配服务顾问
 */
export function distributeAssignee(params) {
    return request('/work-order/assignee/distribution', {
        method: 'PUT',
        params,
    });
}
/**
 *  修改保险信息
 */
export function editInsurance(params) {
    return request('/work-order/insurance', {
        method: 'PUT',
        params,
    });
}
/**
 *  修改责任方
 */
export function editResponsibleParty(params) {
    return request('/work-order/responsible-party', {
        method: 'PUT',
        params,
    });
}
/**
 *  修改工单客户车辆信息
 */
export function editPersonVehicleInfo(params) {
    return request('/work-order/vehicle-person', {
        method: 'PUT',
        params,
    });
}
/**
 *  修改工单成本金额
 */
export function editOverhaulAmount(params) {
    return request('/work-order/overhaul-amount', {
        method: 'PUT',
        params,
    });
}
/**
 *  修改工单结算金额
 */
export function editPaymentAmount(params) {
    return request('/work-order/payment-amount', {
        method: 'PUT',
        params,
    });
}
/**
 *  查询可关联的权益
 */
export function getWorkOrderEquities(id) {
    return request(`/work-order/${id}/equitys`, {
        method: 'GET',
    });
}
